import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { ArrayField } from './ArrayField'
import { BooleanField } from './BooleanField'
import { CategorySelectField } from './CategorySelectField'
import { ColorField } from './ColorField'
import { ImageField } from './ImageField'
import { NumberField } from './NumberField'
import { ObjectField } from './ObjectField'
import { RichTextField } from './RichTextField'
import { SelectField } from './SelectField'
import { StringField } from './StringField'
import { TextField } from './TextField'

interface FieldRendererProps {
  field: FieldSchema
  value: any
  onChange: (value: any) => void
  onImageRequest: (path: string) => void
  path?: string
}

export const FieldRenderer = ({
  field,
  value,
  onChange,
  onImageRequest,
  path = '',
}: FieldRendererProps) => {
  const renderField = (f: FieldSchema, v: any, oc: (val: any) => void, p: string) => (
    <FieldRenderer field={f} value={v} onChange={oc} onImageRequest={onImageRequest} path={p} />
  )

  switch (field.type) {
    case 'string':
      return <StringField field={field} value={value} onChange={onChange} />
    case 'text':
      return <TextField field={field} value={value} onChange={onChange} />
    case 'rich-text':
      return <RichTextField field={field} value={value} onChange={onChange} />
    case 'number':
      return <NumberField field={field} value={value} onChange={onChange} />
    case 'boolean':
      return <BooleanField field={field} value={value} onChange={onChange} />
    case 'select':
      return <SelectField field={field} value={value} onChange={onChange} />
    case 'category-select':
      return <CategorySelectField field={field} value={value} onChange={onChange} />
    case 'color':
      return <ColorField field={field} value={value} onChange={onChange} />
    case 'image':
      return (
        <ImageField
          field={field}
          value={value}
          onChange={onChange}
          onImageRequest={onImageRequest}
          path={path}
        />
      )
    case 'object':
      return (
        <ObjectField
          field={field}
          value={value}
          onChange={onChange}
          onImageRequest={onImageRequest}
          path={path}
          renderField={renderField}
        />
      )
    case 'array':
      return (
        <ArrayField
          field={field}
          value={value}
          onChange={onChange}
          onImageRequest={onImageRequest}
          path={path}
          renderField={renderField}
        />
      )
    default:
      return null
  }
}
